import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { FileText, Calendar, IndianRupee, ChevronRight } from "lucide-react";

const STATUS_TABS = [
  { key: "", label: "All" },
  { key: "open", label: "Open" },
  { key: "closed", label: "Closed" },
  { key: "awarded", label: "Awarded" },
];

function StatusPill({ s }) {
  const map = { open: "badge-status-open", closed: "badge-status-closed", awarded: "badge-status-approved" };
  return <span className={`${map[s] || "badge-status-pending"} capitalize`}>{s}</span>;
}

export default function TendersPage() {
  const [sp, setSp] = useSearchParams();
  const [items, setItems] = useState([]);
  const status = sp.get("status") || "";
  useEffect(() => { api.get("/tenders").then((r) => setItems(r.data.items)); }, []);
  const filtered = items.filter((t) => (status ? t.status === status : true));

  return (
    <div className="container-x py-12">
      <div className="label-tiny text-[hsl(var(--primary))]">Tender Portal</div>
      <h1 className="mt-1 text-3xl lg:text-5xl font-heading font-bold">Public Tenders</h1>
      <p className="mt-3 max-w-2xl text-muted-foreground">All PEDA tenders, bids and awards — fully transparent.</p>

      <div className="mt-6 flex flex-wrap gap-2">
        {STATUS_TABS.map((x) => (
          <button key={x.key} onClick={() => setSp(x.key ? { status: x.key } : {})}
            className={`px-4 py-2 rounded-full text-sm border ${status === x.key ? "bg-[hsl(var(--primary))] text-white border-transparent" : "border-border hover:bg-muted"}`}>
            {x.label}
          </button>
        ))}
      </div>

      <div className="mt-8 space-y-3">
        {filtered.map((t) => (
          <div key={t.id} className="rounded-xl border border-border bg-card p-5 flex items-start gap-4 hover:border-[hsl(var(--primary))] transition-colors">
            <div className="h-12 w-12 rounded-lg bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] grid place-items-center">
              <FileText className="h-5 w-5"/>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <StatusPill s={t.status}/>
                <span className="text-xs text-muted-foreground">{t.tender_no}</span>
                <span className="text-xs text-muted-foreground">· {t.category}</span>
              </div>
              <div className="mt-1 font-heading font-semibold">{t.title}</div>
              <div className="text-xs text-muted-foreground line-clamp-1 mt-0.5">{t.description}</div>
            </div>
            <div className="hidden sm:block text-right">
              <div className="text-xs text-muted-foreground flex items-center gap-1 justify-end"><IndianRupee className="h-3 w-3"/>Value</div>
              <div className="font-semibold">₹{(t.value/1e5).toFixed(1)}L</div>
              <div className="text-xs text-muted-foreground mt-2 flex items-center gap-1 justify-end"><Calendar className="h-3 w-3"/>Closes</div>
              <div className="text-xs font-medium">{t.close_date}</div>
            </div>
            <ChevronRight className="h-4 w-4 text-muted-foreground mt-2"/>
          </div>
        ))}
      </div>
    </div>
  );
}
